import ZaiaLoadingPoints from "./ZaiaLoadingPoints";

export default ZaiaLoadingPoints;